import { requestType } from '~/config/enum.config';
var SERVICE = 'common-service';
var CONTROLLER = 'uploadFileController';
export default {
    /**
     * 上传文件
     */
    upload: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'upload',
        type: requestType.Post
    },
    /**
     * 上传文件
     */
    getUploadFile: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getUploadFile',
        type: requestType.Get
    },
    /**
     *
     */
    getAllUploadFileByIds: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllUploadFileByIds',
        type: requestType.Get
    },
    /**
     * 获取文件流
     */
    getFileStreamById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getFileStreamById',
        type: requestType.Get
    },
    /**
     * 删除文件
     */
    deleteById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'deleteById',
        type: requestType.Get
    }
};
